import {
    handleVisibility,
    renderFlexBoxAlignment,
    renderImageVerticalAlignment,
    HorizontalAlign,
    ImageFit,
    VerticalAlign,
} from '@bigcommerce/page-builder-sdk';
import { css } from 'emotion';

import renderBorderRadius from '../../lib/borderRadius';
import { ProductCardProps, ProductProps, TextStyle } from '../../types/productProps';

export const productCardStyle = css`
    background: transparent;
    box-sizing: border-box;
    height: auto;
`;

export const contentStyle = (props: ProductProps): string => {
    return css`
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        align-items: ${renderFlexBoxAlignment(props.productCardContentAlignment.horizontal)};
    `;
};

export const productImageStyle = (product: ProductCardProps, props: ProductProps): string => {
    return css`
        height: 250px;
        background-image: url("${product.productImage}");
        background-size: ${product.productImageFit === ImageFit.Fit ? 'contain' : 'cover'};
        background-position-x: ${HorizontalAlign.Center};
        background-position-y: ${renderImageVerticalAlignment(VerticalAlign.Middle)};
        background-repeat: no-repeat;
        margin: 16px;
        ${handleVisibility(props.productImage.visibility)};
    `;
};

export const productImageContainer = css`
    width: 100%;
`;

export const productDefaultImageStyle = (props: ProductProps): string => {
    return css`
        background: #d9dce9;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 16px;
        ${handleVisibility(props.productImage.visibility)};
    `;
};

const getTextDefaults = (titleStyle: TextStyle): string => {
    if (titleStyle === TextStyle.DEFAULT) {
        return css`
            font-size: 14px;
            font-weight: 400;
            line-height: 21px;
        `;
    }

    return '';
};

export const productNameStyle = (props: ProductProps): string => {
    return css`
        padding: 0 12px;
        ${handleVisibility(props.productName.visibility)};
        ${getTextDefaults(props.productName.textStyle)};

        a {
            color: ${props.productName.color};
            text-decoration: none;
        }
    `;
};

const getBrandDefaults = (titleStyle: TextStyle): string => {
    if (titleStyle === TextStyle.DEFAULT) {
        return css`
            font-size: 15px;
            font-weight: 400;
            line-height: 23px;
            text-transform: uppercase;
        `;
    }

    return '';
};

export const brandStyle = (props: ProductProps): string => {
    return css`
        padding: 0 12px;
        color: ${props.brand.color};
        ${handleVisibility(props.brand.visibility)};
        ${getBrandDefaults(props.brand.textStyle)};
    `;
};

export const productRatingStyle = (props: ProductProps): string => {
    return css`
        align-items: center;
        justify-content: ${renderFlexBoxAlignment(props.productCardContentAlignment.horizontal)};
        padding: 0 12px;
        margin-top: 8px;
        ${handleVisibility(props.productRating.visibility)};

        span {
            margin-left: 6px;
            color: ${props.productRating.reviewsColor};
        }
    `;
};

export const productPriceStyle = (props: ProductProps): string => {
    return css`
        color: ${props.price.color};
        margin-top: 8px;
        padding: 0 12px;
        ${handleVisibility(props.price.visibility)};
        ${getTextDefaults(props.price.textStyle)};
    `;
};

export const actionsStyle = (props: ProductProps): string => {
    return css`
        padding: 0 12px;
        margin-top: 16px;
        ${handleVisibility(props.button.visibility)};
    `;
};

export const buttonStyle = (props: ProductProps): string => {
    return css`
        color: ${props.button.buttonTextColor};
        background: ${props.button.buttonColor};
        text-decoration: none;
        ${renderBorderRadius(props.button.shape)};
        padding: 10px 20px;
        display: block;
        ${getTextDefaults(props.button.textStyle)};
    `;
};
